
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.07 2v4.342a5.706 5.706 0 013.331 1.974 5.737 5.737 0 011.31 3.651 5.64 5.64 0 01-.448 2.23l3.598 2.405A9.962 9.962 0 0022 11.967c0-2.473-.913-4.86-2.561-6.699A9.987 9.987 0 0013.07 2zM6.288 11.967c0-1.333.464-2.624 1.31-3.65a5.706 5.706 0 013.331-1.975V2a9.987 9.987 0 00-6.368 3.268A10.045 10.045 0 002 11.968a9.961 9.961 0 001.139 4.634l3.598-2.406a5.64 5.64 0 01-.449-2.229zM16.074 15.985a5.703 5.703 0 01-4.072 1.714 5.692 5.692 0 01-4.061-1.714l-3.603 2.406a9.976 9.976 0 003.439 2.661 9.946 9.946 0 004.24.943 9.943 9.943 0 007.675-3.604l-3.618-2.406z"}})])
          )
        }
      }
    